import React from 'react';
import '../../App.css';
import CardGrid from "../CardGrid.js"

export default function Home() {
  return (
    <div className="home">
      <CardGrid />
    </div>
  );
}
